<div class="stripe-payment">
	<!--  RESERVATION FORM  -->

	<form
		name="configure_stripe_reservation_form"
		[formGroup]="stripe_form"
		(submit)="onSubmit()"
		(input)="onFormInput($event)"
		class="form"
		novalidate
	>
		<div class="row form-fields-container">
			<div class="col-xxs-30 col-sm-14">
				<ui-text-control
					[form]="stripe_form"
					[form_control]="stripe_form.controls['first_name']"
					[type]="'text'"
					[label]="'Your First Name'"
					[placeholder]="'Enter your first name...'"
					[max_length]="50"
				></ui-text-control>
			</div>
			<div class="col-xxs-30 col-sm-14 col-sm-offset-2">
				<ui-text-control
					[form]="stripe_form"
					[form_control]="stripe_form.controls['last_name']"
					[type]="'text'"
					[label]="'Your Last Name'"
					[placeholder]="'Enter your last name...'"
					[max_length]="50"
				></ui-text-control>
			</div>
			<div class="col-xxs-30 col-sm-14">
				<ui-text-control
					[form]="stripe_form"
					[form_control]="stripe_form.controls['email']"
					[type]="'text'"
					[label]="'Your Email Address'"
					[placeholder]="'Enter your email address...'"
					[max_length]="255"
				></ui-text-control>
			</div>
			<div class="col-xxs-30 col-sm-14 col-sm-offset-2">
				<ui-text-control
					[form]="stripe_form"
					[form_control]="stripe_form.controls['tel_mob']"
					[type]="'text'"
					[label]="'Your Mobile Number'"
					[placeholder]="'Enter your mobile number...'"
					[max_length]="50"
				></ui-text-control>
			</div>
			<div class="col-xxs-30">
				<div class="card-details-control" [ngClass]="{ 'has-error': card_details_invalid }">
					<label for="card-element-stripe">
						Your Card Details
						<span *ngIf="card_details_invalid">are invalid</span>
					</label>

					<!--  STRIPE CARD DETAILS  -->

					<div id="card-element-stripe"></div>

					<!--  END STRIPE CARD DETAILS  -->
				</div>
			</div>
			<div class="col-xxs-30 terms-control">
				<ui-checkbox-control
					[form]="stripe_form"
					[form_control]="stripe_form.controls['terms']"
					[label]="
						'I agree to the ' +
						(dealer.terms_and_conditions_url ? '|Terms & Conditions*terms-and-conditions|, ' : '') +
						'|Terms of Use*terms-of-use| and |Privacy Policy*privacy-policy'
					"
					(cta)="onTermsCta($event)"
				></ui-checkbox-control>
			</div>

			<!--  TEST MODE NOTIFICATION  -->

			<div *ngIf="test_mode" class="col-xxs-30">
				<div class="heading align-center test-mode">
					<h3>Card Payments are in test mode.</h3>
					<p>
						<strong>Card number with 3D Authentication:</strong>
						4000 0027 6000 3184
						<br />
						<strong>Card number without 3D Authentication</strong>
						4242 4242 4242 4242
						<br />
						<br />
						Expiry -
						<strong>04/24</strong>
						. CVC -
						<strong>242</strong>
						. Zip -
						<strong>42424</strong>
					</p>
				</div>
			</div>

			<!--  END TEST MODE NOTIFICATION  -->

			<button
				class="button positive-button button-with-icon-right"
				[ngClass]="{ disabled: stripe_form.invalid || card_details_invalid || card_details_empty }"
				[class.loading]="sending"
			>
				<span class="loading-spinner"></span>
				<span>
					<i class="icon-padlock"></i>
					<span *ngIf="payment_type === 'reserve'">Reserve for {{ reservation_amount | money: 0 }}</span>
					<span *ngIf="payment_type === 'buyNow'">Buy now for {{ grand_total | currency:'GBP':'symbol':'1.0-2' }}</span>

				</span>
			</button>
		</div>

		<!--  POWERED BY MESSAGE  -->

		<div class="powered-by">
			<p>
				<i class="icon-padlock text-hl"></i>
				Secured by
				<a href="https://stripe.com/gb" target="_blank">
					<img [src]="stripe_logo" alt="Stripe" />
				</a>
			</p>
		</div>

		<!--  END POWERED BY MESSAGE  -->
	</form>

	<!--  END RESERVATION FORM  -->
</div>
